var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire2 = function SvgFire2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7555_7229)",
    d: "M13.977 31.012c-3.389-.33-6.824-1.977-8.518-4.941-1.647-2.965-1.223-6.73-.047-9.977l.988 2.824c.094.282.236.611.47.753.377.235.895.047 1.177-.33.236-.376.283-.847.236-1.27-.142-1.883-1.224-3.624-1.271-5.506-.047-2.165 1.318-4.141 3.012-5.506.047.753.235 1.553.47 2.259.095.282.283.564.565.611a.76.76 0 0 0 .518-.235c1.412-1.176 2.259-2.87 2.588-4.659a7.6 7.6 0 0 0-.047-2.73c-.047-.187-.424-1.129-.33-1.27.142-.282.942.33 1.13.424 3.106 1.976 5.176 5.506 5.223 9.176 0 .565.095 1.318.66 1.412.329.047.658-.141.846-.424.189-.282.189-.611.236-.94 2.211 1.976 3.811 4.423 4.894 7.152.611 1.6 1.035 3.341.706 5.036-.283 1.553-1.036 2.964-2.118 4.14-1.788 2.024-4.188 3.624-6.87 3.907a28.5 28.5 0 0 1-4.518.094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.259 28.847a9 9 0 0 1-.377 1.035c-1.035.565-2.165.941-3.341 1.036a26 26 0 0 1-2.73.14c-.564 0-1.176 0-1.788-.046a12.6 12.6 0 0 1-3.2-.706 6.34 6.34 0 0 1-1.082-2.683c-.33-2.07.282-4.188 1.459-5.929.188-.282.612-.188.706.141.33 1.083 1.035 2.07 1.835 2.918.235.235.612.094.659-.235.094-1.13.33-3.247.753-4.377.517-1.412 1.317-2.776 2.494-3.764.235-.189.565-.095.612.235.235 1.412.94 2.73 1.647 4 .847 1.412 1.788 2.823 2.211 4.423.424 1.177.471 2.541.142 3.812"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD550",
    d: "M22.259 28.847a9 9 0 0 1-.377 1.035c-1.035.565-2.165.941-3.341 1.036a26 26 0 0 1-2.73.14c-.564 0-1.176 0-1.788-.046a12.6 12.6 0 0 1-3.2-.706 6.34 6.34 0 0 1-1.082-2.683c-.33-2.07.282-4.188 1.459-5.929.188-.282.612-.188.706.141.33 1.083 1.035 2.07 1.835 2.918.235.235.612.094.659-.235.094-1.13.33-3.247.753-4.377.517-1.412 1.317-2.776 2.494-3.764.235-.189.565-.095.612.235.235 1.412.94 2.73 1.647 4 .847 1.412 1.788 2.823 2.211 4.423.424 1.177.471 2.541.142 3.812"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_7555_7229)",
    d: "M22.259 28.847a9 9 0 0 1-.377 1.035c-1.035.565-2.165.941-3.341 1.036a26 26 0 0 1-2.73.14c-.564 0-1.176 0-1.788-.046a12.6 12.6 0 0 1-3.2-.706 6.34 6.34 0 0 1-1.082-2.683c-.33-2.07.282-4.188 1.459-5.929.188-.282.612-.188.706.141.33 1.083 1.035 2.07 1.835 2.918.235.235.612.094.659-.235.094-1.13.33-3.247.753-4.377.517-1.412 1.317-2.776 2.494-3.764.235-.189.565-.095.612.235.235 1.412.94 2.73 1.647 4 .847 1.412 1.788 2.823 2.211 4.423.424 1.177.471 2.541.142 3.812"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7555_7229",
    x1: 6.5,
    x2: 25.5,
    y1: 6.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF782F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F32257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7555_7229",
    x1: 15,
    x2: 17,
    y1: 17,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC548"
  })))));
};
export default SvgFire2;